// extracted by mini-css-extract-plugin
export var configurationSection = "_rk-0";